import Card from './card';

export default Card;
export { Card };